var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspendInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16986",
    "data-name": "Group 16986",
    transform: "translate(-975 -25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13675",
    "data-name": "Group 13675",
    transform: "translate(1172.742 -34.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13658",
    "data-name": "Group 13658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11204",
    "data-name": "Path 11204",
    d: "M-165.448,72.75a10.223,10.223,0,0,0-.647-3.38,7.119,7.119,0,0,0-4.074-4.07,10.226,10.226,0,0,0-3.377-.642c-1.485-.074-1.959-.089-5.74-.089s-4.255.015-5.74.083a10.279,10.279,0,0,0-3.38.647,7.124,7.124,0,0,0-4.072,4.072,10.254,10.254,0,0,0-.642,3.381V84.233a10.225,10.225,0,0,0,.641,3.377,7.113,7.113,0,0,0,4.072,4.072,10.173,10.173,0,0,0,3.38.647c1.485.068,1.96.083,5.74.083s4.255-.015,5.74-.083a10.173,10.173,0,0,0,3.38-.647,7.112,7.112,0,0,0,4.073-4.072,10.223,10.223,0,0,0,.647-3.38c.068-1.485.083-1.96.083-5.74S-165.385,74.235-165.448,72.75Z",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11214",
    "data-name": "Path 11214",
    d: "M-179.292,85.644a7.15,7.15,0,0,1-7.15-7.15,7.15,7.15,0,0,1,7.15-7.15,7.15,7.15,0,0,1,7.15,7.15,7.15,7.15,0,0,1-7.15,7.15Z",
    fill: "var(--mainColor)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11215",
    "data-name": "Path 11215",
    d: "M-170.192,71.062h0a1.661,1.661,0,0,1-1.665,1.659,1.662,1.662,0,0,1-1.659-1.665,1.663,1.663,0,0,1,1.665-1.659,1.662,1.662,0,0,1,1.659,1.659Z",
    fill: "var(--mainColor)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-stop_1_",
    "data-name": "icons8-stop (1)",
    d: "M19.5,1A18.5,18.5,0,1,0,38,19.5,18.52,18.52,0,0,0,19.5,1ZM2.762,19.5A16.729,16.729,0,0,1,30.691,7.064L7.067,30.688A16.652,16.652,0,0,1,2.762,19.5ZM19.5,36.238a16.677,16.677,0,0,1-11.191-4.3L31.933,8.312A16.725,16.725,0,0,1,19.5,36.238Z",
    transform: "translate(974 24)",
    fill: "#ff1c00",
    opacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendInsta);
export default __webpack_public_path__ + "static/media/suspend_insta.e0bec302f8d16a1d20c3a005fc395338.svg";
export { ForwardRef as ReactComponent };